"use client";
import { createContext, ReactNode, useContext, useMemo } from "react";
import { MIXPANEL } from "@stadium/services/analytics/constants/services";

type EventLocationContextType = {
  location: string;
  services: readonly string[];
  baseEventLocationProperties: object;
};

const DEFAULT_SERVICES = [MIXPANEL];
const EMPTY_OBJ = {};

const EventLocationContext = createContext<EventLocationContextType>({
  location: "",
  services: DEFAULT_SERVICES,
  baseEventLocationProperties: EMPTY_OBJ,
});

export const useEventLocationContext = () => useContext(EventLocationContext);

export const EventLocationProvider = ({
  location,
  children,
  services = DEFAULT_SERVICES,
  baseEventLocationProperties = EMPTY_OBJ,
}: {
  location: string;
  children: ReactNode;
  services?: readonly string[];
  baseEventLocationProperties?: object;
}) => {
  const value = useMemo(
    () => ({ location, services, baseEventLocationProperties }),
    [location, services, baseEventLocationProperties],
  );

  return <EventLocationContext.Provider value={value}>{children}</EventLocationContext.Provider>;
};
